// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"165":"573d7479","167":"e96fa996","400":"76949567","569":"1080c8a6","688":"2e005778","771":"77b48f8d"}[chunkId] + ".js";
};